import { render } from "./VesselNomination.vue?vue&type=template&id=70a5077c&scoped=true"
import script from "./VesselNomination.vue?vue&type=script&lang=js"
export * from "./VesselNomination.vue?vue&type=script&lang=js"

import "./VesselNomination.vue?vue&type=style&index=0&id=70a5077c&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a5077c"]])

export default __exports__